const ContentSection = ({ paragraphs }) => {
  return (
    <>
      {paragraphs.map((paragraph, i) => (
        <p key={i}>
          {paragraph.map(({ text, highlight }, j) =>
            highlight ? (
              <span key={j} className='font-medium text-black'>
                {text}
              </span>
            ) : (
              <span key={j}>{text}</span>
            )
          )}
        </p>
      ))}
    </>
  );
};
export default ContentSection;
